module.exports = __webpack_public_path__ + "static/img/ticket_item_bg_type2.e76db1cb.png";